/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Contract, ContractFactory, subscribeContractEvent, testMethod, callMethod, multicallMethods, fetchContractState, ContractInstance, getContractEventsCurrentCount, } from "@alephium/web3";
import { default as GovernanceContractJson } from "../Governance.ral.json";
import { getContractByCodeHash } from "./contracts";
class Factory extends ContractFactory {
    constructor() {
        super(...arguments);
        this.eventIndex = { WormholeMessage: 0 };
        this.consts = {
            Version: "01",
            GuardianSetExpireDuration: BigInt(86400000),
            CoreModule: BigInt(1131377253),
            ErrorCodes: {
                InvalidEmitChainId: BigInt(0),
                InvalidEmitAddress: BigInt(1),
                InvalidMessageSize: BigInt(2),
                InvalidSequence: BigInt(3),
                InvalidModule: BigInt(4),
                InvalidActionId: BigInt(5),
                InvalidVersion: BigInt(6),
                InvalidGuardianSetIndex: BigInt(7),
                InvalidGuardianSetSize: BigInt(8),
                InvalidSignatureSize: BigInt(9),
                InvalidSignatureGuardianIndex: BigInt(10),
                InvalidSignature: BigInt(11),
                GuardianSetExpired: BigInt(12),
                InvalidTargetChainId: BigInt(13),
                ContractStateMismatch: BigInt(14),
                InvalidRegisterChainMessage: BigInt(15),
                InvalidTokenId: BigInt(16),
                InvalidNonceSize: BigInt(17),
                TokenNotExist: BigInt(18),
                InvalidTransferTargetChain: BigInt(19),
                InvalidDestroyUnexecutedSequenceMessage: BigInt(20),
                InvalidCaller: BigInt(21),
                ArbiterFeeLessThanAmount: BigInt(22),
                InvalidAttestTokenMessage: BigInt(23),
                InvalidPayloadId: BigInt(24),
                InvalidTransferMessage: BigInt(25),
                ExpectRemoteToken: BigInt(26),
                InvalidConsistencyLevel: BigInt(27),
                InvalidUpdateRefundAddressMessage: BigInt(28),
                TransferAmountLessThanMessageFee: BigInt(29),
                InvalidAttestTokenArg: BigInt(30),
                InvalidAttestTokenHandler: BigInt(31),
                NotSupported: BigInt(32),
            },
            ActionId: {
                ContractUpgrade: "01",
                NewGuardianSet: "02",
                NewMessageFee: "03",
                TransferFee: "04",
            },
        };
        this.tests = {
            getMessageFee: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "getMessageFee", params);
            }),
            publishWormholeMessage: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "publishWormholeMessage", params);
            }),
            parseAndVerifyVAA: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "parseAndVerifyVAA", params);
            }),
            parseAndVerifyGovernanceVAAGeneric: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "parseAndVerifyGovernanceVAAGeneric", params);
            }),
            parseAndVerifyGovernanceVAA: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "parseAndVerifyGovernanceVAA", params);
            }),
            getGuardiansInfo: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "getGuardiansInfo", params);
            }),
            submitContractUpgrade: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "submitContractUpgrade", params);
            }),
            updatePreviousGuardianSet: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "updatePreviousGuardianSet", params);
            }),
            submitNewGuardianSet: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "submitNewGuardianSet", params);
            }),
            submitSetMessageFee: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "submitSetMessageFee", params);
            }),
            submitTransferFees: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "submitTransferFees", params);
            }),
        };
    }
    at(address) {
        return new GovernanceInstance(address);
    }
}
// Use this object to test and deploy the contract
export const Governance = new Factory(Contract.fromJson(GovernanceContractJson, "", "7ebf06319b04aef7a7013a42ea2b7fccb3fc86178c27240aa2b2678d9068d9c7"));
// Use this class to interact with the blockchain
export class GovernanceInstance extends ContractInstance {
    constructor(address) {
        super(address);
        this.methods = {
            getMessageFee: (params) => __awaiter(this, void 0, void 0, function* () {
                return callMethod(Governance, this, "getMessageFee", params === undefined ? {} : params, getContractByCodeHash);
            }),
            parseAndVerifyVAA: (params) => __awaiter(this, void 0, void 0, function* () {
                return callMethod(Governance, this, "parseAndVerifyVAA", params, getContractByCodeHash);
            }),
            parseAndVerifyGovernanceVAAGeneric: (params) => __awaiter(this, void 0, void 0, function* () {
                return callMethod(Governance, this, "parseAndVerifyGovernanceVAAGeneric", params, getContractByCodeHash);
            }),
        };
    }
    fetchState() {
        return __awaiter(this, void 0, void 0, function* () {
            return fetchContractState(Governance, this);
        });
    }
    getContractEventsCurrentCount() {
        return __awaiter(this, void 0, void 0, function* () {
            return getContractEventsCurrentCount(this.address);
        });
    }
    subscribeWormholeMessageEvent(options, fromCount) {
        return subscribeContractEvent(Governance.contract, this, options, "WormholeMessage", fromCount);
    }
    multicall(calls) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield multicallMethods(Governance, this, calls, getContractByCodeHash));
        });
    }
}
